module.exports = __webpack_public_path__ + "img/searchNone.3e326692.png";